import React from "react";
import PodiumSection from "./PodiumSection";
import CollapsibleSection from "./CollapsibleSection";
import TournamentArchive from "Components/Tournament/tournamentArchive";

const RightSidebar = ({
  latestTournamentWithPodium,
  animatePodium,
  locationId,
  isAdmin,
}) => {
  return (
    <div className="space-y-4">
      <PodiumSection
        latestTournamentWithPodium={latestTournamentWithPodium}
        animatePodium={animatePodium}
      />
      <CollapsibleSection title="Archives">
        <TournamentArchive locationId={locationId} isAdmin={isAdmin} />
      </CollapsibleSection>
    </div>
  );
};

export default RightSidebar;
